import './KnownIssuesEditPage.css'
import { useNavigate, useParams } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { IPageProps, IRootState, IParamsType, AlertMessage } from 'types'
import { DefaultButton, FormDropDownList, FormInput, PageHeader, ReturnButton, FormTextArea, FormDateTimePicker, FormMultiSelect } from 'components'
import { useRef, useEffect, useState } from 'react'
import { FormElement, Field, Form, FormClassComponent, } from '@progress/kendo-react-form'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from 'state/store'
import { endLoadingAction, startLoadingAction } from 'state/actions/appActions'
import toast from 'core/toast'
import { KnownIssueDto, UpdateKnownIssueDto } from 'generated/v1/v1IntegrationsApi'
import { V1ApiIntegrationsClient } from 'core/http-common'
import { RequiredValidator } from 'core/Validators'
import moment from 'moment'
import { getErrors } from 'core/helpers'

export interface IParams extends IParamsType {
    id: string
}

const KnownIssuesEditPage = ({ title }: IPageProps) => {

    const { id } = useParams<IParams>()

    const formRef = useRef<FormClassComponent>(null)
    const loading = useSelector((state: IRootState) => state.app.loading)
    const dispatch = useDispatch<AppDispatch>()
    const statusData = ['Reported', 'In Process', 'Awaiting Deployment', 'Deployed', 'Deleted']
    const systemData = ['DCS', 'Sys Admin', 'CMS', 'Mobile', 'Other']
    const navigate = useNavigate()
    const reportDateDefault = moment().toDate()
    const [knownIssue, setKnownIssue] = useState<KnownIssueDto>()
    const [alert, setAlert] = useState<AlertMessage>()

    const [loaded, setLoaded] = useState(false)

    const handleSubmit = async (values: UpdateKnownIssueDto) => {
        try {
            await dispatch(startLoadingAction())

            console.log(values)
            var result = await V1ApiIntegrationsClient.updateKnownIssue(values, undefined)

            if (result.success) {
                toast.success('Successfully updated Known Issue')
                navigate('/integrations/known-issues')
            }
            else {
                toast.responseErrors(result.errors)
            }

        } catch (e) {
            toast.responseErrors(e)
        }
        finally {
            await dispatch(endLoadingAction())
        }
    }

    const fetchKnownIssue = async () => {
        if (!id || !id.trim() || isNaN(Number(id))) {
            // navigate(redirectUrl)
            return
        }

        try {
            //await dispatch(startLoadingAction())
            setAlert({ variant: 'info', messages: [] })
            let knownIssue = await V1ApiIntegrationsClient.getKnownIssue(Number(id))
            console.log(knownIssue)
            setKnownIssue(knownIssue.payload)
            setLoaded(true)
        }
        catch (e) {
            setAlert({ variant: 'danger', messages: getErrors(e) })
        }
        finally {
            window.scrollTo(0, 0)
        }
    }

    useEffect(() => {
        fetchKnownIssue()
    }, [id])


    return (
        <div id='KnownIssuesEditPage'>
            <PageHeader title={title}>
                <ReturnButton redirectUrl='/integrations/known-issues' />
            </PageHeader>

            {loaded &&
                <Form
                    onSubmit={(e) => handleSubmit(e as UpdateKnownIssueDto)}
                    ref={formRef}
                    ignoreModified={true}
                    initialValues={knownIssue}
                    key={JSON.stringify(knownIssue)}
                    render={(formRenderProps) => (
                        <FormElement>
                            <div className='bg-light border p-3'>
                                <Row className='mb-6'>
                                    <Col md={6}>
                                        <Field
                                            label='Title:'
                                            name='title'
                                            component={FormInput}
                                            validator={RequiredValidator}
                                        />
                                    </Col>
                                </Row>
                                <Row className='mb-12'>
                                    <Col md={12}>
                                        <Field
                                            label='Description:'
                                            name='description'
                                            component={FormTextArea}
                                            validator={RequiredValidator}
                                        />
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col md={3}>
                                        <Field
                                            label='Report Date:'
                                            name='reportedDate'
                                            component={FormDateTimePicker}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Field
                                            label='Status:'
                                            name='status'
                                            validator={RequiredValidator}
                                            component={FormDropDownList}
                                            data={statusData}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Field
                                            label='System:'
                                            name='systemArray'
                                            validator={RequiredValidator}
                                            component={FormMultiSelect}
                                            data={systemData}
                                        />
                                    </Col>

                                    <Col md={3} style={{ alignSelf: 'end' }}>
                                        <DefaultButton variant='primary' className='w-100' type='submit'>Update Known Issue</DefaultButton>
                                    </Col>
                                </Row>
                            </div>
                        </FormElement>
                    )
                    }
                />
            }
        </div>
    )
}
export default KnownIssuesEditPage
